import { AccountCardMenuItem, AccountMenuItem, BadgeProps } from '@make-software/csprclick-ui';

const openInNewTab = (url: string) => window.open(url, '_blank');

type MenuItemConfig = {
  label: string;
  url: string;
  badge?: BadgeProps;
  icon?: any;
};

const menuConfig: MenuItemConfig[] = [];

export const accountMenuItems = [
  <AccountCardMenuItem key="account-card" />,
  ...menuConfig.map((item: MenuItemConfig, index: number) => (
    <AccountMenuItem
      key={index}
      onClick={() => openInNewTab(item.url)}
      icon={item.icon}
      label={item.label}
      {...(item.badge && { badge: item.badge })}
    />
  ))
];
